<template>
  <div class="px-3">
    <div
      class="flex flex-row justify-center text-center text-gray-400 mt-32"
      v-if="isCartEmpty"
    >
      <font-awesome-icon icon="shop" class="fa-xl text-bgfont" />
      <h5 class="mr-1">سبد خرید شما خالی است</h5>
    </div>

    <div v-else>
      <div class="bg-red-500 mt-2 p-5 rounded-xl" v-if="error">
        <span class="text-white text-sm" v-html="error"></span>
      </div>
      <h2 class="text-right text-base font-bold pt-4 mr-2">سبد خرید</h2>
      <ShoppingCartItem
        v-for="product in products"
        :key="product.code"
        :product="product"
        class="mt-4"
      />
      <div class="flex flex-col p-2">
        <h2 class="text-right text-base font-bold pt-2 mr-2">
          آدرس انتخاب شده
        </h2>
        <div class="flex items-center justify-center gap-x-1">
          <label
            class="px-2 py-3 shadow-md bg-white rounded-xl text-[12px] w-full max-w-[370px] mx-auto mt-2 mb-4"
            >{{ selectedAddress }}</label
          >
          <button
            @click="navigateUser()"
            class="bg-yellow-400 shadow-md mb-2 text-black px-2 py-3 h-[35px] rounded-lg hover:bg-yellow-300 transition flex items-center justify-center"
          >
            <font-awesome-icon
              icon="fa-solid fa-pen-to-square"
              class="fa-md text-bgfont"
            />
          </button>
        </div>
      </div>
      <div class="flex flex-col w-full max-w-sm mr-2">
        <label for="description" class="font-bold pb-2">توضیحات</label>
        <textarea
          id="description"
          v-model="description"
          rows="4"
          class="p-4 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-1 focus:ring-yellow-500 focus:border-yellow-500 resize-none"
          placeholder="متن خود را اینجا وارد کنید..."
        ></textarea>
      </div>
    </div>
    <div
      class="bg-white p-5 mt-4 rounded-xl text-cyan-900 border-yellow-500 border-2 shadow-md max-w-sm mr-2"
      v-if="!isCartEmpty"
    >
      <table class="table price-table w-full text-sm text-right">
        <tr v-if="!bold">
          <td>تعداد اقلام</td>
          <td>
            <span>{{ `${products.length} عدد` }}</span>
          </td>
        </tr>
        <tr v-else>
          <th class="table-cell-profit">تعداد اقلام</th>
          <th class="table-cell-profit text-green-500">
            {{ `${products.length} عدد` }}
          </th>
        </tr>
        <tr v-if="!bold">
          <td>جمع کل (با مالیات)</td>
          <td>
            <span>{{ $helper.priceFormatter(totalPriceBeforeDiscount) }}</span>
          </td>
        </tr>
        <tr v-else>
          <th class="table-cell-profit">تعداد اقلام</th>
          <th class="table-cell-profit text-green-500">
            {{ $helper.priceFormatter(totalPriceBeforeDiscount) }}
          </th>
        </tr>
        <tr v-if="profit > 0">
          <td>جمع تخفیف</td>
          <td>
            <span>{{ $helper.priceFormatter(profit) }}</span>
          </td>
        </tr>
        <tr>
          <th class="table-cell-profit">مبلغ قابل پرداخت</th>
          <th class="table-cell-profit text-bgfont">
            {{ $helper.priceFormatter(totalPriceAfterDiscount) }}
          </th>
        </tr>
      </table>
    </div>
    <div class="h-8" v-if="!isCartEmpty"></div>
  </div>

  <div class="grid grid-cols-3 bottom-20 mt-0 mx-2" v-if="!isCartEmpty">
    <button
      class="bg-bgbutton p-2 rounded-3xl border border-yellow-500 text-cyan-900 shadow-lg disabled:bg-gray-400 disabled:cursor-not-allowed"
      :disabled="loading"
      @click="submitCart()"
    >
      ثبت
    </button>
    <button
      class="bg-bgbutton p-2 rounded-3xl border border-yellow-500 text-cyan-900 mr-1 shadow-lg"
      @click="getProduct()"
    >
      محصولات
    </button>
    <button
      class="bg-bgbutton p-2 rounded-3xl border border-yellow-500 text-cyan-900 mr-1 shadow-lg"
      @click="clearCart()"
    >
      حذف
    </button>
  </div>
</template>
<script>
import ShoppingCartItem from "@/components/ShoppingCartItem";
import { mapGetters } from "vuex";
import { postShoppingCart } from "../API/API";

export default {
  name: "ShoppingCart",
  data() {
    return {
      paymentType: "cash",
      showProduct: false,
      error: "",
      cuid: localStorage.getItem("selectedCustomer"),
      result: [],
      shoMelli: "",
      shoPost: "",
      shoEghtesadi: "",
      selectedAddress: localStorage.getItem("selectedAddress"),
      loading: false,
      description: "",
    };
  },
  created() {
    if (this.dCustomer.length > 0) {
      for (let i = 0; i < this.dCustomer[0].length; i++) {
        if (this.dCustomer[0][i].customerId == this.cuid) {
          this.shoMelli = this.dCustomer[0][i].customer.shO_Meli;
          this.shoPost = this.dCustomer[0][i].customer.shO_POSTI;
          this.shoEghtesadi = this.dCustomer[0][i].customer.shO_EGHTESADI;
        }
      }
    }
  },
  components: {
    ShoppingCartItem,
  },
  mounted() {
    localStorage.removeItem("cartError");
  },
  computed: {
    cartError() {
      return localStorage.getItem("cartError");
    },
    products() {
      return JSON.parse(JSON.stringify(this.$store.state.cart.products));
    },
    dCustomer() {
      return this.$store.state.cart.detailCustomer;
    },
    ...mapGetters("cart", [
      "totalPriceAfterDiscount",
      "totalPriceBeforeDiscount",
      "isCartEmpty",
    ]),
  },
  methods: {
    autoResize(event) {
      const textarea = event.target;
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    },
    // submitCart() {
    //   this.loading = true;
    //   let products = this.$store.state.cart.products;
    //   let cart = {
    //     paymentType: this.paymentType,
    //     basketDetails: products,
    //     customerId: this.cuid,
    //     anbarId: 1,
    //     id: Number(JSON.parse(JSON.stringify(this.$store.state.cart.orderId))),
    //     shO_Meli: this.shoMelli,
    //     shO_POSTI: this.shoPost,
    //     shO_EGHTESADI: this.shoEghtesadi,
    //     address_Id: Number(localStorage.getItem("selectedAddressId")),
    //     description: this.description,
    //   };
    //   postShoppingCart(cart).then((rsp) => {
    //     if (rsp.data.statusCode == 422) {
    //       let unorderedList = document.createElement("div");
    //       unorderedList.classList.add("text-sm", "text-right", "list-disc");
    //       rsp.data.result.basketDetails.forEach((error) => {
    //         if (error.errors !== undefined && error.errors !== null) {
    //           let h = document.createElement("h4");
    //           h.classList.add("mb-2", "mt-3", "font-bold");
    //           h.innerHTML = error.kala_Name + " :";
    //           unorderedList.appendChild(h);
    //           error.errors.forEach((er) => {
    //             let span = document.createElement("span");
    //             span.innerHTML = er.errorMessage;
    //             unorderedList.appendChild(span);
    //           });
    //         }
    //       });
    //       this.$store.dispatch("cart/addCartError", unorderedList.outerHTML);
    //       this.$store.dispatch(
    //         "cart/changeCart",
    //         rsp.data.result.basketDetails
    //       );
    //       this.$swal({
    //         icon: "error",
    //         title: "خطا",
    //         text: "عملیات با شکست مواجه",
    //         confirmButtonColor: "#fcd34d",
    //         confirmButtonText: "باشه",
    //       }).then(() => {
    //         this.error = localStorage.getItem("cartError");
    //         this.$router.replace("/cart");
    //       });
    //     } else {
    //       this.$swal({
    //         icon: "success",
    //         title: "موفقیت",
    //         text: `ثبت خرید شما باموفقیت ثبت شد`,
    //         confirmButtonColor: "#fcd34d",
    //         confirmButtonText: "باشه",
    //       }).then(() => {
    //         this.$store.dispatch("cart/emptyCart");
    //         this.$router.replace("/customer");
    //       });
    //     }
    //   });
    // },
    async submitCart() {
      this.loading = true;

      try {
        const products = this.$store.state.cart.products;

        const cart = {
          paymentType: this.paymentType,
          basketDetails: products,
          customerId: this.cuid,
          anbarId: 1,
          id: Number(
            JSON.parse(JSON.stringify(this.$store.state.cart.orderId))
          ),
          shO_Meli: this.shoMelli,
          shO_POSTI: this.shoPost,
          shO_EGHTESADI: this.shoEghtesadi,
          address_Id: Number(localStorage.getItem("selectedAddressId")),
          description: this.description,
        };

        const rsp = await postShoppingCart(cart);

        /* --- اگر خطای اعتبارسنجی بود (422) --- */
        if (rsp.data.statusCode === 422) {
          await this.$swal({
            icon: "error",
            title: "خطا",
            text: rsp.data.result,
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });

          // ذخیره خطا در استور
          this.$store.dispatch("cart/addCartError", rsp.data.result);

          // اگر لازم باشد محصولات را هم بروزرسانی کن
          if (rsp.data.result?.basketDetails) {
            this.$store.dispatch(
              "cart/changeCart",
              rsp.data.result.basketDetails
            );
          }

          // مقدار خطا
          this.error = localStorage.getItem("cartError");

          // ❗ مهم: روی همان صفحه باقی می‌ماند، هیچ مسیری تغییر نمی‌کند
          return;
        }

        /* --- موفقیت در ثبت خرید --- */
        await this.$swal({
          icon: "success",
          title: "موفقیت",
          text: "ثبت خرید با موفقیت انجام شد",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });

        this.$store.dispatch("cart/emptyCart");
        this.$router.replace("/customer");
      } catch (error) {
        console.error("خطا در ارسال خرید:", error);

        await this.$swal({
          icon: "error",
          title: "خطا",
          text: "مشکلی در ثبت خرید رخ داد!",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });
      } finally {
        this.loading = false;
      }
    },
    // async submitCart() {
    //   this.loading = true;

    //   try {
    //     let products = this.$store.state.cart.products;
    //     let cart = {
    //       paymentType: this.paymentType,
    //       basketDetails: products,
    //       customerId: this.cuid,
    //       anbarId: 1,
    //       id: Number(
    //         JSON.parse(JSON.stringify(this.$store.state.cart.orderId))
    //       ),
    //       shO_Meli: this.shoMelli,
    //       shO_POSTI: this.shoPost,
    //       shO_EGHTESADI: this.shoEghtesadi,
    //       address_Id: Number(localStorage.getItem("selectedAddressId")),
    //       description: this.description,
    //     };

    //     const rsp = await postShoppingCart(cart);
    //     if (rsp.data.statusCode === 422) {
    //       console.log(rsp.data);
    //       await this.$swal({
    //         icon: "error",
    //         title: "خطا",
    //         text: rsp.data.result,
    //         confirmButtonColor: "#fcd34d",
    //         confirmButtonText: "باشه",
    //       });

    //       this.$store.dispatch("cart/addCartError", rsp.data.result);
    //       this.$store.dispatch(
    //         "cart/changeCart",
    //         rsp.data.result.basketDetails
    //       );

    //       this.error = localStorage.getItem("cartError");
    //       this.$router.replace("/cart");
    //     } else {
    //       await this.$swal({
    //         icon: "success",
    //         title: "موفقیت",
    //         text: "ثبت خرید شما با موفقیت انجام شد",
    //         confirmButtonColor: "#fcd34d",
    //         confirmButtonText: "باشه",
    //       });

    //       this.$store.dispatch("cart/emptyCart");
    //       this.$router.replace("/customer");
    //     }
    //   } catch (error) {
    //     console.error("خطا در ارسال خرید:", error);
    //     await this.$swal({
    //       icon: "error",
    //       title: "خطا",
    //       text: "مشکلی در ثبت خرید رخ داد!",
    //       confirmButtonColor: "#fcd34d",
    //       confirmButtonText: "باشه",
    //     });
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    getProduct() {
      let customer = localStorage.getItem("selectedCustomer");
      this.$router.push(`customer/${customer}/anbar/1`);
    },
    clearCart() {
      this.$store.dispatch("cart/emptyCart");
    },
    navigateUser() {
      this.$router.push(`address/${this.cuid}`);
    },
  },
};
</script>
